import browserHistory from 'react-router/lib/browserHistory';
import { AUTH_DISCARD_USER } from '../auth/constants';

function isPromise(value) {
  if (value !== null && typeof value === 'object') {
    return value && typeof value.then === 'function';
  }

  return false;
}

const authInterceptor = ({ dispatch }) => next => (action) => {
  const result = next(action);
  if (isPromise(result)) {
    return result.catch((error) => {
      if (error.message === 'Unauthorized' || error.code === 'ServiceUnavailable') {
        browserHistory.push('/login');
        dispatch({ type: AUTH_DISCARD_USER });
      }

      return Promise.reject(error);
    });
  }

  return result;
};

export default authInterceptor;
